import { get } from 'lodash/fp';
import axios from './axios';

export default (configurationGuid, newWindowName) =>
  axios.get(`/designs/configurations/${configurationGuid}/copy`, {
    params: {
      newWindowName,
    },
  }).then(get('data'));
